// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class BlanketOrderService {
  public redirectFrom: any;
  webOrderNumber: any;

  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  public setRedirectionFrom(value) {
    this.redirectFrom = value;
  }

  // check blanket order tab access
  public checkBlanketOrderTabAccess() {
    return this.networkService.getRequest(this.configService.getBlanketOrderAccess());
  }

  // Get blanket Order Items List
  public blanetOrderItemsList(filters) {
    return this.networkService.postRequest(this.configService.getBlanketOrderItemsData(), filters);
  }

  // Get blanket Order Export List
  public blanetOrderExportList(filters) {
    return this.networkService.postRequest(this.configService.getblanetOrderExportList(), filters);
  }

  // Get blanket shipto list
  public blanketShipToList() {
    return this.networkService.getRequest(this.configService.getBlanketShipToListData());
  }

  // Get All blanket Item List for Add Product Slider
  public getAllBlanketItemList(filters) {
    return this.networkService.postRequest(this.configService.getAllBlanketItemListData(), filters);
  }

  // Get data for EA order Summary data
  public getBlanketEditOrder(webOrderNumber) {
    return this.networkService.getRequest(this.configService.getBlanketEditOrder() + '?webOrderNumber=' + webOrderNumber);
  }

  // Check Account for existing draft order
  public getExisitngDraftOrder(accountNumber) {
    return this.networkService.getRequest(this.configService.getExisitingDraftOrder() + '?accountNumber=' + accountNumber);
  }

  // Get data for EA order Summary data
  public getOrderSummaryDetails(webOrderNumber) {
    return this.networkService.getRequest(this.configService.getEAOrderSummaryDetails() + '?webOrderNumber=' + webOrderNumber);
  }

  public uploadProductExcel(filters) {
    return this.networkService.postRequest(this.configService.uploadProductExcelData(), filters);
  }

  public downloadProductExcel() {
    return this.networkService.getRequest(this.configService.downloadProductExcelData());
  }

  // Place Order
  public placeOrder(saveObj) {
    return this.networkService.postRequest(this.configService.placeBlanketOrder(), saveObj);
  }

  // Save Order
  public saveOrder(saveObj) {
    return this.networkService.postRequest(this.configService.saveBlanketOrder(), saveObj);
  }

  // pdf from base64 date
  public sendBaseDate(filters) {
    return this.networkService.postRequest(this.configService.postFileForPdf(), filters);
  }

  // send Blanket Order Confirmation Email
  public sendBlanketOrderConfirmationEmail(emailObject) {
    return this.networkService.postRequest(this.configService.sendBlanketOrderConfirmationEmail(), emailObject);
  }

  // Delete Blanket Order
  public deleteBlanketOrder(orderNumber) {
    return this.networkService.postRequest(this.configService.deleteBlanketOrder(), orderNumber);
  }
}
